import { 
  updateEventiOrdini,
  updateMenu,
  updateAutorizzazioni,
  updateLanguages,
  updateCapigruppo,
  updateNumeratori, 
  updateStatiReclamo,
  updateStatiOrdine,
  formDataUpdate, 
  rangeToDates, 
  datesToRange,
  gridExportExcel,
  hasTableHiddenFilters
} from 'System/actions/common.js';
import { 
  routeParamsCacheSave,
  routeParamsCacheSave2,
  routeParamsCacheGet,
	routeChange, 
	routesTreeToggle, 
	routesTreeOpen, 
	routeChangeWithLink, 
	routeReload, 
	bookmarkSave, 
  bookmarkRemove,
  ssoRedirect
} from 'System/actions/routes.js';
import { 
  appUpgrade,
  appReset,
  init,
  initCore,
  userReset,
  userLogin, 
  userAuth,
  trySsoLogin,
  userLogout, 
  userProjectionClose,
  menuLoad,
  languageChange,
  passwordReset } from 'System/actions/user.js';
import { 
  notificationAdd, 
  loadingAdd, 
  loadingRemove, 
  loadingClear } from 'System/actions/notifications.js';
import { 
  uiScrollTop, 
  uiSidebarToggle, 
  uiLanguageChange, 
  uiAreasToggle, 
  uiViewModeChange, 
  uiGridOptionsToggle, 
  uiGridTotalizationsToggle,
  uiChangeTableFontSize,
  uiScrollInfoUpdate,
  uiChangeFilter
} from 'System/actions/ui.js';
import { 
  downloadSingle, 
  showSingle,
  downloadAll,
  filePreview,
  downloadClear,
  showDataTouch } from 'System/actions/files.js';
import { 
  modalClose, 
  modalCloseAll, 
  modalOpen } from 'System/actions/modals.js';
import { 
  log } from 'System/actions/developer.js';
import { 
  dataLayer,
  dataRequest } from 'System/actions/network.js';

import * as comunicazioni from 'System/actions/comunicazioni.js';

import * as sso from 'System/actions/sso.js';

const actions = {
  init,
  initCore,
  updateEventiOrdini,
  updateMenu,
  updateAutorizzazioni,
  updateLanguages,
  updateCapigruppo,
  updateNumeratori, 
  updateStatiOrdine,
  updateStatiReclamo,
  formDataUpdate,
  gridExportExcel,
  hasTableHiddenFilters,
  rangeToDates, 
  datesToRange,
  updateCapigruppo,
  menuLoad,
  routeParamsCacheSave,
  routeParamsCacheSave2,
  routeParamsCacheGet,
  routeChange,
  routeChangeWithLink,
  routesTreeToggle,
  routesTreeOpen,
  routeReload,
  bookmarkSave,
  bookmarkRemove,
  ssoRedirect,
  appUpgrade,
  appReset,
  userReset,
  userLogin,
  userAuth,
  trySsoLogin,
  userLogout, 
  passwordReset,
  userProjectionClose,
  languageChange,
  notificationAdd, 
  loadingAdd, 
  loadingRemove, 
  loadingClear,
  uiSidebarToggle, 
  uiAreasToggle,
  uiChangeTableFontSize,
  uiViewModeChange,
  uiGridOptionsToggle,
  uiGridTotalizationsToggle,
  uiScrollTop,
  uiScrollInfoUpdate,
  uiChangeFilter,
  downloadSingle,
  showSingle,
  filePreview,
  downloadAll,
  downloadClear,
  modalClose, 
  modalCloseAll,
  modalOpen,
  log,
  dataLayer,
  dataRequest,
  showDataTouch,
  ...comunicazioni,
  ...sso
}


export default actions;